import { render } from "./ApprovalsMenu.vue?vue&type=template&id=df608716"
import script from "./ApprovalsMenu.vue?vue&type=script&lang=js"
export * from "./ApprovalsMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__